import http from "../js/axios";
import { addAuthParams } from "../js/common";
class ShoppingSerive {
  list() {
    let params = addAuthParams({});
    return http.get("/Admin/Services/Shopping.asmx/Shopping_Item_List", {
      params,
    });
  }
  order(params) {
    params = addAuthParams(params);
    return http.get("/Admin/Services/Shopping.asmx/DoShopping", {
      params,
    });
  }
}
export default new ShoppingSerive();
